import CashRegisterServ from '@api/CashRegister/CashRegisterServ';
import { CashRegister, CashRegisterStatus } from '@api/CashRegister/CashRegister';
class CashRegisterService {
    openCashRegister = (amount: number): Promise<CashRegister> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.openCashRegister(amount);
                resolve(data);
            } catch (error) {
                reject('Error saving cash register: ' + error);
            }
        });
    };

    getCashRegistersByDate = (date: Date, branchOfficeId?: string): Promise<CashRegister[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.getCashRegistersByDate(date, branchOfficeId);
                resolve(data);
            } catch (error) {
                reject('Error getting cash registers: ' + error);
            }
        });
    };

    // Panel de cajas del admin (un día, todas las sucursales)
    getCashRegistersByRange = (startDate: Date, endDate: Date, branchOfficeId?: string): Promise<CashRegister[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.getCashRegistersByRange(startDate, endDate, branchOfficeId);
                resolve(data);
            } catch (error) {
                reject('Error getting cash registers: ' + error);
            }
        });
    };

    createCashRegisterForDate = (params: {
        branchOfficeId: string;
        date: Date;
        initialCash: number;
        status?: CashRegisterStatus;
    }): Promise<CashRegister> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.createCashRegisterForDate(params);
                resolve(data);
            } catch (error) {
                reject('Error creating cash register: ' + error);
            }
        });
    };

    updateCashRegister = (cashRegisterId: string, changes: { initialCash?: number; date?: Date }): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CashRegisterServ.updateCashRegister(cashRegisterId, changes);
                resolve();
            } catch (error) {
                reject('Error updating cash register: ' + error);
            }
        });
    };

    reopenCashRegister = (cashRegisterId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CashRegisterServ.reopenCashRegister(cashRegisterId);
                resolve();
            } catch (error) {
                reject('Error reopening cash register: ' + error);
            }
        });
    };

    getCashRegister = (cashRegisterId: string): Promise<CashRegister | undefined> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.getCashRegister(cashRegisterId);
                resolve(data);
            } catch (error) {
                reject('Error getting cash register: ' + error);
            }
        });
    };

    updateInitialAmount = (cashRegisterId: string, newAmount: number): Promise<CashRegister> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.updateInitialAmount(cashRegisterId, newAmount);
                resolve(data);
            } catch (error) {
                reject('Error saving cash register: ' + error);
            }
        });
    };

    closeCashRegister = (
        cashRegisterId: string,
        closing?: { countedCash: number; expectedCash: number; note?: string }
    ): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CashRegisterServ.closeCashRegister(cashRegisterId, closing);
                resolve();
            } catch (error) {
                reject('Error closing cash register: ' + error);
            }
        });
    };

    getTodayOpenCashRegister = (branchOfficeId?: string): Promise<CashRegister | undefined> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.getTodayOpenCashRegister(branchOfficeId);
                resolve(data);
            } catch (error) {
                reject('Error getting open cash register: ' + error);
            }
        });
    };

    getOpenCashRegistersFromPreviousDays = (branchOfficeId?: string): Promise<CashRegister[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashRegisterServ.getOpenCashRegistersFromPreviousDays(branchOfficeId);
                resolve(data);
            } catch (error) {
                reject('Error getting open cash registers: ' + error);
            }
        });
    };
}
export default CashRegisterService;
